import { Check } from '@mui/icons-material'
import * as React from 'react'
import StandardButton from '../buttons/standard-button'

import { colors } from '../../constants/colors'

import { ButtonProps } from '@mui/material'
import { HBox } from '../../elements/basic-elements'

const ResultCardCtaSingle = ({
  isCompleted,
  label,
  icon,
  ...buttonProps
}: {
  isCompleted?: boolean
  label: React.ReactNode
  icon?: React.ReactNode
} & ButtonProps) => {
  const hasIcon = icon || isCompleted
  return (
    <StandardButton
      variant="contained"
      disableElevation
      color={isCompleted ? 'success' : 'primary'}
      startIcon={hasIcon && (isCompleted ? <Check sx={{ width: 24, height: 24 }} /> : icon)}
      {...buttonProps}
      sx={{
        color: colors.WHITE,
        width: '100%',
        ...buttonProps?.sx
      }}
    >
      <HBox flex={1} justifyContent="center" mx={hasIcon ? 1 : 0}>
        {label}
      </HBox>
    </StandardButton>
  )
}

export default ResultCardCtaSingle
